import React, { useState } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const FogetPasswordForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post("/api/accounts/forgot_password/", {
        email: values.email,
      });

      if (response.status === 200) {
        message.success(
          "Mail sent successfully, please check your email for reset password!"
        );
        localStorage.setItem("emailForReset", values.email);
        form.resetFields();
        navigate("/reset_password_prompt", { replace: true });
      }
    } catch (error) {
      if (error.response) {
        message.error(`Mail sent failed: ${error.response.data.message}`);
      } else {
        message.error("Network error, please try again!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row justify="center" style={{ marginTop: 100 }}>
      <Col xs={24} sm={12} md={8} lg={6}>
        <div style={{ padding: 24, background: "#fff", borderRadius: 4 }}>
          <h2 style={{ textAlign: "center", marginBottom: 24 }}>
            Reset Password Request
          </h2>
          <Form
            form={form}
            name="reset_password"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="Enter Email" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Reset Password
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  );
};

export default FogetPasswordForm;
